<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3n0pPr/Images/Cover.jpg?1727443786974" alt="This image is the cover for the book Ghost Town"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ghost Town
      </h1>
      <p class="bookDescription body article font2">
        <p>A NEW YORK TIMES MOST ANTICIPATED BOOK OF FALL 2022  FROM THE BEST-SELLING AUTHOR &amp; WINNER OF THE TAIWAN LITERATURE AWARD  Keith Chen, the second son of a traditional Taiwanese family of seven, runs away from the oppression of his village to Berlin in the hope of finding acceptance as a young gay man.  The novel begins a decade later, when Chen has just been released from prison for killing his boyfriend. He is about to return to his family’s village, a poor and desolate place. With his parents gone, his sisters married, mad, or dead, there is nothing left for him there. As the story unfurls, we learn what tore this family apart and, more importantly, the truth behind the murder of Chen’s boyfriend.  Told in a myriad of voices, both living and dead, and moving through time with deceptive ease, Ghost Town weaves a mesmerizing web of family secrets and countryside superstitions, the search for identity and clash of cultures.  ? “Multidimensional characters, a beautifully realized setting, and an apposite surprise ending... This book is excellent.”—Booklist (Starred Review)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kevin Chen
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Europa Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?48d31f95